module.exports = __webpack_public_path__ + "static/media/PasswordChecker1.94388835.svg";